const regiones = {
  "Region Aysen del Gral.Carlos Ibañez del Campo": [
    "Coihaique",
    "Aisen",
    "Chile Chico",
    "Cisnes",
    "Cochrane",
    "Futaleufu",
    "Guaitecas",
    "Lago Verde",
    "O’Higgins",
    "Palena",
    "Rio Ibañez",
    "Tortel"
  ],
  "Region Metropolitana de Santiago": [
    "El Monte",
    "Alhue",
    "Curacavi",
    "Maria Pinto",
    "San Pedro",
    "Melipilla",
    "Peñaflor",
    "Talagante",
    "Lampa",
    "Tiltil",
    "Las Condes",
    "Conchali",
    "Recoleta",
    "Huechuraba",
    "Santiago",
    "Lo Barnechea",
    "Providencia",
    "Vitacura",
    "La Reina",
    "La Florida",
    "Ñuñoa",
    "Peñalolen",
    "Colina",
    "Puente Alto",
    "Macul",
    "La Cisterna",
    "La Granja",
    "La Pintana",
    "San Ramon",
    "El Bosque",
    "Independencia",
    "Quilicura",
    "Renca",
    "San Joaquin",
    "Cerro Navia",
    "Quinta Normal",
    "Cerrillos",
    "Estacion Central",
    "Lo Espejo",
    "Lo Prado",
    "Maipu",
    "Padre Hurtado",
    "Pedro Aguirre Cerda",
    "Pudahuel",
    "San Bernardo",
    "San Miguel",
    "San Jose de Maipo",
    "Pirque",
    "Isla de Maipo",
    "Buin",
    "Paine",
    "Calera de Tango"
  ],
  "Region de Antofagasta": [
    "Antofagasta",
    "Mejillones",
    "Taltal",
    "Calama",
    "San Pedro de Atacama",
    "Tocopilla",
    "Maria Elena",
    "Sierra Gorda"
  ],
  "Region de Arica y Parinacota": [
    "Arica"
  ],
  "Region de Atacama": [
    "Copiapo",
    "Tierra Amarilla",
    "Chañaral",
    "Diego de Almagro",
    "Vallenar",
    "Alto del Carmen",
    "Freirina",
    "Huasco",
    "Caldera"
  ],
  "Region de Coquimbo": [
    "Andacollo",
    "Coquimbo",
    "La Higuera",
    "La Serena",
    "Paiguano",
    "Vicuña",
    "Combarbala",
    "Monte Patria",
    "Ovalle",
    "Punitaqui",
    "Rio Hurtado",
    "Canela",
    "Illapel",
    "Los Vilos",
    "Salamanca"
  ],
  "Region de La Araucania": [
    "Renaico",
    "Los Sauces",
    "Puren",
    "Curacautin",
    "Lumaco",
    "Traiguen",
    "Victoria",
    "Carahue",
    "Cholchol",
    "Freire",
    "Galvarino",
    "Gorbea",
    "Lautaro",
    "Nueva Imperial",
    "Padre Las Casas",
    "Perquenco",
    "Pitrufquen",
    "Saavedra",
    "Temuco",
    "Teodoro Schmidt",
    "Tolten",
    "Vilcun",
    "Curarrehue",
    "Pucon",
    "Villarrica",
    "Angol",
    "Collipulli",
    "Ercilla",
    "Lonquimay",
    "Cunco",
    "Melipeuco",
    "Loncoche"
  ],
  "Region de Los Lagos": [
    "Puerto Montt",
    "Calbuco",
    "Cochamo",
    "Los Muermos",
    "Maullin",
    "Hualaihue",
    "Fresia",
    "Frutillar",
    "Llanquihue",
    "Puerto Varas",
    "Osorno",
    "Puerto Octay",
    "Purranque",
    "Puyehue",
    "Rio Negro",
    "San Juan de la Costa",
    "San Pablo",
    "Chaiten"
  ],
  "Region de Los Lagos (Chiloe)": [
    "Ancud",
    "Castro",
    "Chonchi",
    "Curaco de Velez",
    "Dalcahue",
    "Puqueldon",
    "Queilen",
    "Quellon",
    "Quemchi",
    "Quinchao"
  ],
  "Region de Los Rios": [
    "La Union",
    "Lago Ranco",
    "Rio Bueno",
    "Valdivia",
    "Corral",
    "Los Lagos",
    "Paillaco",
    "Futrono",
    "Panguipulli",
    "Lanco",
    "Mafil",
    "Mariquina"
  ],
  "Region de Magallanes y de la Antartica Chilena": [
    "Porvenir",
    "Punta Arenas",
    "Cabo de Hornos (Ex. Navarino) / Puerto Williams",
    "Natales"
  ],
  "Region de Tarapaca": [
    "Alto Hospicio",
    "Huara",
    "Pica",
    "Pozo Almonte",
    "Iquique"
  ],
  "Region de Valparaiso": [
    "Concon",
    "Valparaiso",
    "Viña del Mar",
    "Calera",
    "Hijuelas",
    "La Cruz",
    "Nogales",
    "Quillota",
    "Calle Larga",
    "Los Andes",
    "Rinconada",
    "San Esteban",
    "Casablanca",
    "Algarrobo",
    "Cartagena",
    "El Quisco",
    "El Tabo",
    "San Antonio",
    "Santo Domingo",
    "Isla de Pascua",
    "Catemu",
    "Llaillay",
    "Panquehue",
    "Putaendo",
    "San Felipe",
    "Santa Maria",
    "Limache",
    "Olmue",
    "Quilpue",
    "Villa Alemana",
    "Puchuncavi",
    "Quintero",
    "Cabildo",
    "Petorca",
    "La Ligua",
    "Papudo",
    "Zapallar"
  ],
  "Region de Ñuble": [
    "Coelemu",
    "Treguaco",
    "Yungay",
    "Coihueco",
    "Portezuelo",
    "Ranquil",
    "Bulnes",
    "El Carmen",
    "Pemuco",
    "Pinto",
    "Quillon",
    "San Ignacio",
    "Chillan",
    "Chillan Viejo",
    "Ñiquen",
    "San Carlos",
    "San Fabian",
    "San Nicolas",
    "Cobquecura",
    "Ninhue",
    "Quirihue"
  ],
  "Region del Biobio": [
    "Concepcion",
    "Penco",
    "Tome",
    "Alto Biobio",
    "Antuco",
    "Cabrero",
    "Laja",
    "Los angeles",
    "Mulchen",
    "Nacimiento",
    "Negrete",
    "Quilaco",
    "Quilleco",
    "San Rosendo",
    "Santa Barbara",
    "Yumbel",
    "Tucapel",
    "Florida",
    "Santa Juana",
    "Arauco",
    "Cañete",
    "Contulmo",
    "Curanilahue",
    "Lebu",
    "Los alamos",
    "Tirua",
    "Chiguayante",
    "Hualqui",
    "Coronel",
    "Hualpen",
    "Lota",
    "San Pedro de la Paz",
    "Talcahuano"
  ],
  "Region del Libertador Gral. Bernardo O’Higgins": [
    "Navidad",
    "Codegua",
    "Coinco",
    "Coltauco",
    "Doñihue",
    "Graneros",
    "Machali",
    "Mostazal",
    "Olivar",
    "Requinoa",
    "Rancagua",
    "La Estrella",
    "Litueche",
    "Las Cabras",
    "Malloa",
    "Peumo",
    "Pichidegua",
    "Quinta de Tilcoco",
    "Rengo",
    "San Vicente",
    "Chepica",
    "Chimbarongo",
    "Nancagua",
    "Placilla",
    "San Fernando",
    "Lolol",
    "Palmilla",
    "Peralillo",
    "Pumanque",
    "Santa Cruz",
    "Marchihue",
    "Paredones",
    "Pichilemu"
  ],
  "Region del Maule": [
    "Maule",
    "Pencahue",
    "San Clemente",
    "San Rafael",
    "Talca",
    "San Javier",
    "Curepto",
    "Licanten",
    "Hualañe",
    "Vichuquen",
    "Pelarco",
    "Rio Claro",
    "Curico",
    "Molina",
    "Rauco",
    "Romeral",
    "Sagrada Familia",
    "Teno",
    "Colbun",
    "Linares",
    "Villa Alegre",
    "Yerbas Buenas",
    "Longavi",
    "Retiro",
    "Constitucion",
    "Empedrado",
    "Chanco",
    "Pelluhue",
    "Cauquenes",
    "Parral"
  ]
};